import { Route, Routes } from "react-router";
import { PageNotFound } from "../components/pageNotFound";
import { Admin } from "../pages/admin";
import { Home } from "../pages/home/container";
import { PostAds } from "../pages/postsAds";

import { CategoriesPage } from "../pages/categories/containers";
import { AddAssociated } from "../pages/private/add-associated";
import { AddAssociatedSaude } from "../pages/private/add-associated-saude";
import { GestaoConveniadosSaude } from "../pages/private/gestao-conveniado-saude/container";
import { GestaoConveniados } from "../pages/private/gestao-conveniado/container";
import { AdminNoticias } from "../pages/private/adminNoticias";
import { Post } from "../pages/private/posts";
import { News } from "../pages/news";

export const PrivateRoutes = () => {
  return (
    <Routes>
      <Route path="/home" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/noticia/delete" element={<AdminNoticias />} />
      <Route path="/noticia/post" element={<Post />} />
      <Route path="/noticia/:slug" element={<News />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/ads/post" element={<PostAds />} />
      <Route path="/parceiros" element={<CategoriesPage />} />
      <Route
        path="/parceiros/categoria/:category"
        element={<CategoriesPage />}
      />
      <Route path="/conveniado/gestao" element={<GestaoConveniados />} />
      <Route path="/conveniado/adicionar" element={<AddAssociated />} />
      <Route
        path="/conveniado-saude/adicionar"
        element={<AddAssociatedSaude />}
      />
      <Route
        path="/conveniado/gestao-saude"
        element={<GestaoConveniadosSaude />}
      />
      <Route path="/login" element={<Admin />} />
      <Route path="/login/" element={<Admin />} />
      <Route path="/*" element={<PageNotFound isPageNotFound />} />
    </Routes>
  );
};
